
// Componente para mostrar advertencias o precauciones con icono y tooltip
  import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
  export default class GWarningMessage extends Vue {
  // Mensaje a mostrar en el tooltip
  @Prop({ type: String, required: true }) readonly message!: string
  // Icono a mostrar (por defecto mdiAlertOutline)
  @Prop({ type: String, default: 'mdi-alert-outline' }) readonly icon!: string
  // Color del icono (por defecto anaranjado)
  @Prop({ type: String, default: 'orange' }) readonly color!: string
  }
